import axios from "axios";
import ErrorParser from '../../services/error.parser';

const DatalevelsService = {
  datalevels: async function () {
    const requestData = {
      method: "get",
      url: "/api/datalevels"
    };
    try {
      const response = await axios(requestData);
      return JSON.parse(response.data);
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
};

export default DatalevelsService;

